function n(n){return r=>{n.forEach(n=>{"function"==typeof n?n(r):null!=n&&(n.current=r)})}}export{n as mergeRefs};
